import gsap from "gsap"
import SplitText from "gsap/SplitText"

gsap.registerPlugin(SplitText)

export function initNavbar() {

  // 1. Element Selectors (Updated to match your new HTML structure)
  const body = document.querySelector("body")
  const topLogo = document.querySelector(".nav-logo") // Target the top header logo
  const navToggle = document.querySelector(".nav-toggle")
  const navToggleMenu = document.querySelector(".nav-toggle-menu")
  const navToggleClose = document.querySelector(".nav-toggle-close")
  const menu = document.querySelector(".menu")
  const menuBg = document.querySelector("#menu-path")
  const menuBgSvg = document.querySelector(".menu-bg-svg")
  const menuLogo = document.querySelector(".menu-logo")
  const menuLinks = document.querySelectorAll(".menu-col-links a")
  const menuInfoItems = document.querySelectorAll(".menu-col-info p, .menu-col-info h3, .menu-col-info h6")

  // Gatekeeper fallback
  if (!navToggle || !menuBg || !menuBgSvg) {
    console.error("Setup failed: Essential DOM components are missing.")
    return
  }

  // 2. Module State Scopes
  let isOpen = false
  let isAnimating = false

  // 3. SVG Calculations & Dimensions
  const svgWidth = menuBgSvg.viewBox.baseVal.width
  const svgHeight = menuBgSvg.viewBox.baseVal.height
  const svgCenterX = svgWidth / 2

  // 4. Fluid Morphing Coordinate Path Strings
  const OPEN_HIDDEN = `M${svgWidth}, 0 Q${svgCenterX}, 0 0, 0 L0, 0 L${svgWidth}, 0 Z`
  const OPEN_BULGE = `M${svgWidth}, 345 Q${svgCenterX}, 620 0, 345 L0, 0 L${svgWidth}, 0 Z`
  const OPEN_FULL = `M${svgWidth}, ${svgHeight} Q${svgCenterX}, ${svgHeight} 0, ${svgHeight} L0, 0 L${svgWidth}, 0 Z`

  const CLOSE_START = `M${svgWidth},0 Q${svgCenterX},0 0, 0 L0, ${svgHeight} L${svgWidth}, ${svgHeight} Z`
  const CLOSE_BULGE = `M${svgWidth}, 350 Q${svgCenterX}, 130 0, 350 L0, ${svgHeight} L${svgWidth}, ${svgHeight} Z`
  const CLOSE_HIDDEN = `M${svgWidth}, ${svgHeight} Q${svgCenterX}, ${svgHeight} 0, ${svgHeight} L0, ${svgHeight} Z`

  // 5. Initial Layout State Configurations
  gsap.set(menuBg, {
    attr: { d: OPEN_HIDDEN }
  })

  const splits = []
  menuLinks.forEach(link => {
    const split = new SplitText(link, {
      type: "chars",
      charsClass: "char"
    })
    splits.push(split)
    gsap.set(split.chars, { opacity: 0, y: 100 })
  })

  gsap.set(menuInfoItems, { opacity: 0, y: 100 })

  // 6. Isolated Internal Animation Functions
  const openMenu = () => {
    menu.classList.remove("invisible")
    menu.classList.add("is-open")
    body.classList.add("overflow-hidden")

    // Fade out top header logo smoothly, fade in close button
    gsap.to(topLogo, { duration: 0.2, opacity: 0, ease: "none" })
    gsap.to(navToggleMenu, { duration: 0.25, opacity: 0, ease: "none" })
    gsap.to(navToggleClose, {
      duration: 0.25,
      opacity: 1,
      ease: "none",
      delay: 0.25
    })

    const tl = gsap.timeline({
      onComplete: () => {
        isAnimating = false
      }
    })

    tl.to(menuBg, {
      duration: 0.5,
      attr: { d: OPEN_BULGE },
      ease: "power4.in"
    }).to(menuBg, {
      duration: 0.5,
      attr: { d: OPEN_FULL },
      ease: "power4.out"
    })

    tl.to(menuLogo, { duration: 0.1, opacity: 1, ease: "none" }, "-=0.75")

    tl.to(
      menuInfoItems,
      {
        duration: 0.75,
        opacity: 1,
        y: 0,
        ease: "power3.out",
        stagger: 0.075
      },
      "-=0.35"
    )

    const menuLinksChars = splits.flatMap(s => s.chars)

    tl.to(
      menuLinksChars,
      {
        duration: 0.75,
        opacity: 1,
        y: 0,
        ease: "power2.out",
        stagger: 0.01
      },
      0.45
    )
  }

  const closeMenu = () => {
    gsap.set(menuBg, { attr: { d: CLOSE_START } })
    gsap.to(navToggleClose, { duration: 0.3, opacity: 0, ease: "none", delay: 0.25 })

    const tl = gsap.timeline({
      onComplete: () => {
        menu.classList.remove("is-open")
        menu.classList.add("invisible")
        body.classList.remove("overflow-hidden")
        gsap.set(menuBg, { attr: { d: OPEN_HIDDEN } })

        splits.forEach(split => {
          gsap.set(split.chars, { opacity: 0, y: 100, x: 0 })
        })

        gsap.set(menuLinks, { opacity: 1 })
        gsap.set(menuInfoItems, { opacity: 0, y: 100 })

        // Bring back top logo smoothly
        gsap.to(topLogo, { duration: 0.3, opacity: 1 })

        isAnimating = false
      }
    })

    tl
    .to(menuLogo, { duration: 0.3, opacity: 0 }).to(menuLinks, { duration: 0.3, opacity: 0 }, "<")
    .to(menuInfoItems, { duration: 0.3, opacity: 0 }, "<")
    .to(navToggleMenu, { duration: 0.25, opacity: 1, ease: "none" })

    tl.to(
      menuBg,
      {
        duration: 0.5,
        attr: { d: CLOSE_BULGE },
        ease: "power3.in"
      },
      "<"
    ).to(menuBg, {
      duration: 0.5,
      attr: { d: CLOSE_HIDDEN },
      ease: "power3.out"
    })
  }

  // 7. Core Event Binding Hook
  navToggle.addEventListener("click", () => {
    console.log("Click registered on navToggle target node.")
    if (isAnimating) {
      console.log("Click ignored: Timeline is currently animating.")
      return
    }
    isAnimating = true
    isOpen = !isOpen
    isOpen ? openMenu() : closeMenu()
  })
}